import React from 'react'

export default function PhoneQr() {
  return (
    <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.0718 16.0715V10.7144H19.6432" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M30.3574 30.3572H33.9289V26.7858" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M21.4289 30.3571V25H16.0718" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M28.5718 10.7144H33.9289V19.6429" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M23.2144 17.8572L26.7858 19.6429" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M37.5001 1.78577H12.5001C10.5277 1.78577 8.92871 3.38475 8.92871 5.35719V44.6429C8.92871 46.6154 10.5277 48.2143 12.5001 48.2143H37.5001C39.4726 48.2143 41.0716 46.6154 41.0716 44.6429V5.35719C41.0716 3.38475 39.4726 1.78577 37.5001 1.78577Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M23.2144 39.2858H26.7858" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
